// src/config/hazardConfig.js
// import { HAZARD_VISIBILITY } from "./hazardVisibility";
import { HAZARD_VISIBILITY } from "../context/HazardVisibility";

const safeString = (val) =>
  typeof val === "string" ? val.trim() : "";

const normalizeHazardId = (val) =>
  safeString(val)
    .toLowerCase()
    .replace(/_/g, "-")
    .replace(/\s+/g, "-");

export const HAZARD_LABEL_TO_ID = {
  Routine: "routine",
  Flooding: "flooding",
  Hurricane: "hurricane",
  "Severe Storms": "severe-storms",
  Tornado: "tornado",
  Wildfire: "wildfire",
  "Winter Weather": "winter-weather",
  "Extreme Heat": "extreme-heat",
  "Extreme Cold": "extreme-cold",
  "High Winds": "high-winds",
  "Dense Fog": "dense-fog",
  "Surf & Rip Currents": "surf-rip-currents",
  Drought: "drought",
};

export const HAZARD_ID_TO_LABEL = Object.fromEntries(
  Object.entries(HAZARD_LABEL_TO_ID).map(([label, id]) => [id, label])
);

export const getHazardId = (label) => {
  if (!label) return "";
  if (HAZARD_ID_TO_LABEL[label]) return HAZARD_LABEL_TO_ID[label];
  return normalizeHazardId(label);
};

export const getHazardLabel = (id) => {
  if (!id) return "";
  return HAZARD_ID_TO_LABEL[normalizeHazardId(id)] || "";
};

export const isHazardVisible = (labelOrId) => {
  if (!labelOrId) return false;

  const directLabelMatch =
    Object.prototype.hasOwnProperty.call(HAZARD_VISIBILITY, labelOrId);

  if (directLabelMatch) {
    return HAZARD_VISIBILITY[labelOrId] === true;
  }

  const normalizedId = normalizeHazardId(labelOrId);
  const label = HAZARD_ID_TO_LABEL[normalizedId];

  if (!label) return false;

  return HAZARD_VISIBILITY[label] === true;
};

export const getVisibleHazardLabels = () =>
  Object.entries(HAZARD_VISIBILITY)
    .filter(([, visible]) => visible === true)
    .map(([label]) => label);

export const getVisibleHazardIds = () =>
  getVisibleHazardLabels()
    .map((label) => getHazardId(label))
    .filter(Boolean);

export const isVisibleHazardId = (hazardId) =>
  isHazardVisible(normalizeHazardId(hazardId));

export { normalizeHazardId };